import React, { useState, useEffect } from "react";
import {
  BiRightArrowAlt,
  BiSolidArrowToRight,
  BiSolidXCircle,
  BiXCircle,
  BiImage,
  BiTrashAlt,
  BiCheck,
} from "react-icons/bi";
import {
  BsArrow90DegRight,
  BsArrowRight,
  BsFillClockFill,
} from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { Button, Input } from "reactstrap";
import { applyCustomFontStyles, isPlainWhiteBackground, THEME_SETTING } from "../data";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import GrpBannerModal from "../../groups/Components/GrpBannerModal";
import QuizTimer from "./QuizTimer";
import parse from "html-react-parser";
import MessagingSurvey from "./MessaginSurvey";
import { USER_CONTENT_WARNING_TEXT } from "../../../utils/userContentWarning";

import ReactPlayer from "react-player";
import moment from "moment";
import { setCurrentQuizExternalUserdata } from "../../../modules/actions";
import RangeInput from "../../../components/RangeInput/RangeInput";
import { getTextFromLanguageCodeAndKey } from "../languages";
import { stripParagraphTags } from "../../../utils/stringUtils";

export default function TriviaQuestionsBlock({
  question,
  jumpToNextStep,
  view,
  themeSettings,
  currentIndex,
  selectAnswer,
  selectedAnswer,
  noOfQuestions,
  isMobileView,
  demoPreview,
  totalQuizSeconds,
  quizData,
  noOfMCQs,
  hideTimer,
  isOpenQuiz,
  previewOnly,
  trivvyLanguage,
  userContentWarning,
  isMessaging
}) {
  const isMobile = isMobileView;
  const [hoveredOption, setHoveredOption] = useState(null);

  const [timedout, setTimedout] = useState(false);
  const [disableBtnForce, setDisableBtnForce] = useState(false);
  const [nextClicked, setNextClicked] = useState(false);

  const [startTime, setStartTime] = useState(null);

  const [isBannerOpen, setIsBannerOpen] = useState(false);

  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  useEffect(() => {
    setTimedout(false);
    setNextClicked(false);

    setStartTime(moment());
  }, [question.question_id]);

  const isLastQuestion =
    quizData && quizData.questions && question
      ? quizData.questions.findIndex(
          x => x.question_id == question.question_id
        ) ==
        quizData.questions.length - 1
      : false;

  const getOptionName = index => {
    return index + 1;
  };

  const selectOption = answer => {
    const time = moment().diff(startTime, "seconds");
    selectAnswer(question, answer, time + 1, "MCQ");
  };
  const selectMultipleOption = option => {
    const time = moment().diff(startTime, "seconds");
    const current = selectedAnswer && Array.isArray(selectedAnswer) ? selectedAnswer : [];
    const exists = current.find(x => x.option_id == option.option_id);
    const next = exists
      ? current.filter(x => x.option_id != option.option_id)
      : [...current, { option_id: option.option_id, text: option.text }];
    selectAnswer(question, next, time + 1, "CHECKBOX");
  };
  const selectInputAnswer = (answer, type) => {
    if (typeof answer == "string") {
      answer = answer.replace(/^\s+/, "");
    }
    const time = moment().diff(startTime, "seconds");

    selectAnswer(question, answer, time + 1, type);
  };

  const questionTimeout = async() => {
    const time = moment().diff(startTime, "seconds");
    selectAnswer({ ...question, currentIndex }, null, time, question.question_type);
    setTimedout(true);
    if(!isLastQuestion){
      jumpToNextStep(currentIndex + 1);
    }

  };
  const mediaObject =
    question.media_url &&
    Array.isArray(question.media_url) &&
    question.media_url.length > 0
      ? question.media_url[0]
      : null;

  const inputLimitCheck = text => {
    if (text) {
      if (text.trim().length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const disableOKButtonMobile = () => {

    if (disableBtnForce) {
      return true;
    }
    if (question.question_type === "CHECKBOX") {
      if (question.isRequired) {
        return !(selectedAnswer && Array.isArray(selectedAnswer) && selectedAnswer.length > 0);
      }
      return false;
    }
    if (question.question_type != "MCQ") {
      if (question.isRequired) {
        if (selectedAnswer && selectedAnswer.text) {
          if (question.question_type === "TEXT") {
            return !inputLimitCheck(selectedAnswer.text);
          }
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    } else {
      if (question.isRequired) {
        if (selectedAnswer) {
          return false;
        } else {
          return true;
        }
      } else {
        return question.isRequired;
      }
    }
  };

  const showOkBtnConditionForDesktop = () => {
    if(previewOnly || demoPreview){
      return false
    }
    if (question.question_type === "CHECKBOX") {
      if (selectedAnswer && Array.isArray(selectedAnswer) && selectedAnswer.length > 0) {
        return true;
      }
      return !question.isRequired;
    }
    if (question.question_type == "MCQ") {
      if (selectedAnswer) {
        return true;
      }
      return !question.isRequired;
    } else if (question.question_type != "MCQ") {
      if (question.isRequired) {
        if (selectedAnswer && selectedAnswer.text) {
          if (question.question_type === "TEXT") {
            return inputLimitCheck(selectedAnswer.text);
          }
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  };

  return (
    <div
      className={`SurveyQuestionsBlock_mainWrapper SurveyWelcomeBlock_fullHeight ${
        isPlainWhiteBackground(themeSettings) ? "bwai-canvas-plain" : ""
      }`}
      style={{
        ...(isOpenQuiz && {
          minHeight: "100vh",
          maxHeight: "100vh",
          overflowY: "auto",
        }),
        ...applyCustomFontStyles(themeSettings)
      }}
    >
      <div
        className="SurveyQuestionsBlock_mainWrapper_questions"
        style={{
          ...(demoPreview && {
            top: "0px",
          }),
          ...(isOpenQuiz && {
            top: "10px",
          }),
        }}
      >
        {/*{quizData.averageRating > 0 ? (
          <h5 className="text-right">
            Ratings : {quizData.averageRating || 0}/10
          </h5>
        ) : (
          ""
        )}*/}
        {!hideTimer && (
          <div>
            {["MCQ", "CHECKBOX"].includes(question.question_type) &&
              question.correct_options &&
              question.correct_options.length > 0 &&
              quizData.timedQuestionsEnable && (
                <div className="my-2">
                  {timedout ? (
                    <h2 className="text-danger text-center">
                      {getTextFromLanguageCodeAndKey(trivvyLanguage,"timedOut")} <BsFillClockFill className="ml-3" />{" "}
                    </h2>
                  ) : (
                    <QuizTimer
                      currentQuestion={question}
                      onTimeEnd={() => {
                        questionTimeout();
                      }}
                      lastQuestionRestrict={() => {
                        if (isLastQuestion) {
                          setTimeout(() => {
                            setDisableBtnForce(true);
                          }, 300);
                        } else {
                          //nothing
                        }
                      }}
                      themeSettings={themeSettings}
                      isMobile={isMobile}
                      demoPreview={demoPreview}
                      timerLimit={Math.round(totalQuizSeconds / noOfMCQs)}
                    />
                  )}
                </div>
              )}
          </div>
        )}
        <div className="my-3 questionOf text-center">
          {getTextFromLanguageCodeAndKey(trivvyLanguage,"question")} {question.order} {getTextFromLanguageCodeAndKey(trivvyLanguage,"of")} {noOfQuestions}
        </div>
        <div className="trivia-survey-edit-questions-ui_question_title pl-0">
          <span
            className="trivia-survey-edit-questions-ui_question_title_qPointer"
            style={{
              fontSize: "18px",
              paddingTop: "4px",
            }}
          >
            {question.order}{" "}
            <BiRightArrowAlt className="font-weight-bolder" size={16} />{" "}
          </span>{" "}
          <span
            className={
              isMobile
                ? "edit_survey_question_wrapper_noborder_mobile"
                : "edit_survey_question_wrapper_noborder"
            }
            style={{
              fontSize: isMobile ? "16px" : "20px",
            }}
          >
            {parse(question.question_text || "<p></p>")}
          </span>
          {question.isRequired ? (
            <span className="font-13px ml-2 text-danger">*Required</span>
          ) : null}
          <ReactTooltip />
        </div>
        {mediaObject && mediaObject.url ? (
          <div style={{ marginBlockStart: "1em", paddingInlineStart: "0px" }}>
            <div className={isMobile ? "trivia-assets":"trivia-assets ml-5"}>
              {mediaObject &&
              mediaObject.type &&
              mediaObject.type.indexOf("video") > -1 ? (
                <ReactPlayer
                  height={demoPreview ? "150px" : isMobile ? "150px" : "300px"}
                  width={demoPreview ? "250px" : isMobile ? "275px" : "550px"}
                  playing={true}
                  playsinline
                  loop={true}
                  muted
                  controls={true}
                  url={mediaObject && mediaObject.url}
                  // style={{ backgroundColor: "black" }}
                />
              ) : (
                <img
                  src={mediaObject && mediaObject.url}
                  style={{
                    height: demoPreview
                      ? "150px"
                      : isMobile
                      ? "150px"
                      : "300px",
                    width: demoPreview ? "250px" : isMobile ? "275px" : "550px",
                  }}
                />
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        {question.question_type == "MCQ" ? (
          <div className={`mt-4 ${isMobile?"":"pl-5"}`}>
            <ul
              style={{
                width:  "auto",
                paddingInlineStart: "0px",
                fontSize:isMobile?"14px":"17px"
              }}
            >
              {!timedout &&
                (question.options || []).map((x, idx) => {
                  const isSelected =
                    selectedAnswer && selectedAnswer.option_id == x.option_id;
                  return (
                    <li
                      key={idx}
                      className={`trivia-survey-edit-questions-ui_option_item ${
                        isSelected ? "selected" : ""
                      }`}
                      onMouseEnter={() => setHoveredOption(idx)}
                      onMouseLeave={() => setHoveredOption(null)}
                      style={{
                        paddingRight: "20px",
                        backgroundColor:
                          hoveredOption === idx
                            ? themeSettings.quizTextColor
                            : isSelected
                            ? themeSettings.quizBackgroundColor
                            : "white",
                        color:
                        hoveredOption === idx
                        ? themeSettings.quizBackgroundColor
                        : isSelected
                        ? themeSettings.quizTextColor
                        : "black",
                        boxShadow: ` 0px 0px 0px ${
                          isSelected ? "2px" : "1px"
                        } ${themeSettings.quizTextColor}`,
                      }}
                      onClick={() => {
                        if (demoPreview || previewOnly) {
                          selectOption(x);
                        } else {
                          selectOption(x);
                        }
                      }}
                    >
                      <span
                        className="option_name_wrapper"
                        style={{
                          backgroundColor: isSelected
                            ? themeSettings.quizTextColor
                            : "inherit",
                          color: isSelected
                            ? themeSettings.quizBackgroundColor
                            : "inherit",
                        }}
                      >
                        {getOptionName(idx)}
                      </span>{" "}
                      <span> {parse(stripParagraphTags(x.text) || "")} </span>
                    </li>
                  );
                })}
            </ul>
          </div>
        ) : question.question_type == "CHECKBOX" ? (
          <div className={`mt-4 ${isMobile?"":"pl-5"}`}>
            {/* Web/email takers get the same "select all that apply" hint the
                SMS already shows (textSMSTrivvyController buildSMStext). */}
            <p
              style={{
                fontStyle: "italic",
                fontSize: isMobile ? "13px" : "15px",
                marginBottom: "10px",
                color: themeSettings.quizTextColor,
              }}
            >
              Note: Please select all that apply.
            </p>
            <ul
              style={{
                width:  "auto",
                paddingInlineStart: "0px",
                fontSize:isMobile?"14px":"17px"
              }}
            >
              {!timedout &&
               (question.options || []).map((x, idx) => {
                  const isSelected = !!(
                    selectedAnswer &&
                    Array.isArray(selectedAnswer) &&
                    selectedAnswer.find(a => a.option_id == x.option_id)
                  );
                  return (
                    <li
                      key={idx}
                      className={`trivia-survey-edit-questions-ui_option_item ${
                        isSelected ? "selected" : ""
                      }`}
                      onMouseEnter={() => setHoveredOption(idx)}
                      onMouseLeave={() => setHoveredOption(null)}
                      style={{
                        paddingRight: "20px",
                        backgroundColor:
                          hoveredOption === idx
                            ? themeSettings.quizTextColor
                            : isSelected
                            ? themeSettings.quizBackgroundColor
                            : "white",
                        color:
                          hoveredOption === idx
                            ? themeSettings.quizBackgroundColor
                            : isSelected
                            ? themeSettings.quizTextColor
                            : "black",
                        boxShadow: ` 0px 0px 0px ${
                          isSelected ? "2px" : "1px"
                        } ${themeSettings.quizTextColor}`,
                      }}
                      onClick={() => {
                        if (demoPreview || previewOnly) {
                          selectMultipleOption(x);
                        } else {
                          selectMultipleOption(x);
                        }
                      }}
                    >
                      <span
                        className="option_name_wrapper"
                        style={{
                          backgroundColor: isSelected
                            ? themeSettings.quizTextColor
                            : "inherit",
                          color: isSelected
                            ? themeSettings.quizBackgroundColor
                            : "inherit",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => {}}
                          style={{ pointerEvents: "none" }}
                        />
                      </span>{" "}
                      <span> {parse(stripParagraphTags(x.text) || "")} </span>
                    </li>
                  );
                })}
            </ul>
          </div>
        ) : question.question_type == "TEXT" ? (
          <div className={`${isMobile?"":"ml-5"}`}>
            <Input
              type="textarea"
              className="question_component_sample_input ml-4"
              placeholder="Please type your input here..."
              value={(selectedAnswer && selectedAnswer.text) || ""}
              onChange={e => {
                if (demoPreview || previewOnly) {
                } else {
                  selectInputAnswer(e.target.value, "TEXT");
                }
              }}
              style={{
                width: isMobile ? "300px" : "600px",
              }}
              rows={5}
            />
            {userContentWarning && !demoPreview && !previewOnly && (
              <p className="text-muted ml-4 mt-2 mb-0">
                <small>{USER_CONTENT_WARNING_TEXT}</small>
              </p>
            )}
          </div>
        ) : question.question_type == "LINEAR_NUMERIC" ? (
          <div>
            <RangeInput
              className={`mt-3 ${isMobile?"":"ml-5"}`}
              min={question.linearNumericConfigs.min}
              max={question.linearNumericConfigs.max}
              minLabel={question.linearNumericConfigs.minLabel || ""}
              maxLabel={question.linearNumericConfigs.maxLabel || ""}
              value={selectedAnswer && selectedAnswer.text}
              onChange={value => {
                if (demoPreview || previewOnly) {
                } else {
                  selectInputAnswer(value, "LINEAR_NUMERIC");
                }
              }}
              themeSettings={themeSettings}
              options={question.isLikert ? question.options || [] : []}
            />
          </div>
        ) : (
          ""
        )}

        {isMobile  ? (
          <div
            className="mt-2"
            style={{
              marginBlockStart: "1em",
              paddingInlineStart: "0px",
              height: "60px",
              marginBottom: "30px",
            }}
          >
          {
            demoPreview || previewOnly ? "" :    <Button
            className="trivia_welcome_page_next_button_sm"
            style={{
              backgroundColor: isHovering
              ? "#ff4500"
              : themeSettings.quizTextColor,
            color: isHovering ? "white": themeSettings.quizBackgroundColor ,
              width: "100px",
              borderColor: themeSettings.quizTextColor,
              border: `1px solid ${themeSettings.quizTextColor}`,
            }}
            disabled={disableOKButtonMobile() || nextClicked}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={() => { setNextClicked(true); jumpToNextStep(currentIndex + 1); }}
            size="sm"
          >
             {getTextFromLanguageCodeAndKey(trivvyLanguage,"next")} <BiCheck size={18} />
          </Button>
          }
         
          </div>
        ) : demoPreview || previewOnly ? (
          ""
        ) : (
          <div
            className="mt-5"
            style={{
              marginBlockStart: "1em",
              paddingInlineStart: "0px",
              height: "60px",
            }}
          >
            {" "}
            <Button
              className="trivia_welcome_page_next_button_sm ml-5"
              style={{
                backgroundColor: isHovering
                  ? "#ff4500"
                  : themeSettings.quizTextColor,
                color: isHovering ? "white": themeSettings.quizBackgroundColor ,
                width: "100px",
                borderColor: themeSettings.quizTextColor,
                border: `1px solid ${themeSettings.quizTextColor}`,
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={() => { setNextClicked(true); jumpToNextStep(currentIndex + 1); }}
              disabled={disableOKButtonMobile() || nextClicked}
              size="sm"
            >
              {getTextFromLanguageCodeAndKey(trivvyLanguage,"next")} <BiCheck size={18} />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
